import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import ReactStars from "react-rating-stars-component";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { toast } from "react-toastify";

const UsersRating = ({
  getUserListsHod,
  usersListingUnderHod = [],
  saveTheUserRating,
  saveUsersRating = [],
  fetchRatingEmailDropdown,
  emailDropdownFilter = [],
  match,
  history,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [inputFields, setInputFields] = useState({ rating: "", remark: "" });
  const [userId, setUserId] = useState(null);
  const [disableRating, setDisableRating] = useState(false);

  const Headers = [
    "Name",
    "Email",
    "Meeting Count(Last Month)",
    "Rated Meeting(Last Month)",
    "Avg. Score",
    "HOD Rating",
    "HOD Feedback",
    "Rated By",
    "Rating Date",
    "Rate",
    "View",
    ""
  ];

  useEffect(() => {
    if (getUserListsHod !== null)
      (async () => {
        setIsLoading(true);
        await getUserListsHod(null, 1);
        await fetchRatingEmailDropdown();
        setIsLoading(false);
      })();
  }, [getUserListsHod]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A"; // Handle null or undefined dates
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  
  

  useEffect(() => {
    const tableData = [
      "id",
      "name",
      "email",
      "meetings_count",
      "total_rated_meetings",
      "average_rating",
      "hod_rating",
      "hod_remark",
      "rated_by",
      "rating_date",
      "Rate",
      "Action",
      "already_rated"
    ];
    if (
      usersListingUnderHod &&
      usersListingUnderHod.data &&
      usersListingUnderHod.data.data
    ) {
      const data = usersListingUnderHod.data.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: key === "rating_date" ? formatDate(element[key]) : element[key],
          })),  
          {
            Action: [
              {
                name: "View Details",
                link: `${baseUrl}/brand-activation/user-details`,
              },
            ],
          }
        )
      );
      if (data) {
        setListData(data);
      } else {
        setListData([]);
      }

      setPageCount(
        Math.ceil(
          usersListingUnderHod.data.total / usersListingUnderHod.data.per_page
        )
      );
    }
  }, [usersListingUnderHod]);

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getUserListsHod(filter, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const handleRating = async (id) => {
    setIsModal(true);
    setUserId(id);
  };

  const handleModalHide = () => {
    setIsModal(false);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("ratingFilter",JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getUserListsHod(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const handleSubmit = async () => {
    const payload = {
      user_id: userId,
      rating: inputFields?.rating,
      remark: inputFields?.remark,
    };
    setIsLoading(true);
    const res = await saveTheUserRating(payload);
    if (res?.status === 200) {
      setDisableRating(true);
      setIsModal(false);
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.userRating}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={Headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={usersListingUnderHod?.data?.from}
        handleRating={handleRating}
        disableRating={disableRating}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        meetingRatingsFilter
        emailDropdownFilter={emailDropdownFilter}
        type={"HOD"}
        userFilter={true}
        localstorageKey={'meeting_rating_filter'}
      />
      <ModalPop
        title={"Rate User"}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="d-flex" style={{ justifyContent: "center" }}>
            <ReactStars
              count={5}
              onChange={(val) =>
                setInputFields({ ...inputFields, rating: val })
              }
              size={40}
              activeColor="#ffd700"
            />
          </div>
          <div className="col-md-12">
            <TextAreaInput
              inputValue={
                inputFields?.remark !== null ? inputFields?.remark : ""
              }
              className={`${
                !inputFields.remark && "empty"
              } inline-css scrollbar-styling`}
              rows={4}
              type="text"
              label={localization.remark}
              required
              isStarRequired={true}
              errorMsg={localization.isRequired}
              handleChange={(e) =>
                setInputFields({ ...inputFields, remark: e.target.value })
              }
            />
          </div>
          <div className="col-md-3">
            <button className="btn btn-success" onClick={handleSubmit}>
              Rate
            </button>
          </div>
        </div>
      </ModalPop>
    </Layout>
  );
};

UsersRating.propTypes = {
  usersListingUnderHod: PropTypes.any,
  getUserListsHod: PropTypes.func,
  match: PropTypes.any,
};

export default UsersRating;
